import { Lock } from 'lucide-react'
import type { ReactElement } from 'react'
import styled from 'styled-components'

const BADGE_HEIGHT = 16
const ICON_SIZE = 9
const PADDING_X = 4
const ICON_GAP = 2
const CHARACTER_WIDTH = 6.5
const CORNER_OVERLAP = 4

const ScreenScale = styled.g`
  color: var(--color-white);
  transform: scale(var(--flow-image-scale, 1));
  transform-origin: 0 0;
`
const Pill = styled.rect`
  fill: var(--pnid-isolation-point);
  stroke: var(--color-white);
  stroke-width: 1;
`
const Label = styled.text`
  fill: currentColor;
  font-size: 0.6875rem;
  font-weight: 700;
  dominant-baseline: central;
`

export type IsolationBadgeProps = { x: number; y: number; label: string }

export function IsolationBadge({
  x,
  y,
  label,
}: IsolationBadgeProps): ReactElement {
  const left = -CORNER_OVERLAP
  const top = CORNER_OVERLAP - BADGE_HEIGHT
  const width =
    PADDING_X * 2 + ICON_SIZE + ICON_GAP + label.length * CHARACTER_WIDTH
  return (
    <g transform={`translate(${x} ${y})`} data-isolation-badge={label}>
      <ScreenScale>
        <Pill
          x={left}
          y={top}
          width={width}
          height={BADGE_HEIGHT}
          rx={BADGE_HEIGHT / 2}
        />
        <Lock
          x={left + PADDING_X}
          y={top + (BADGE_HEIGHT - ICON_SIZE) / 2}
          size={ICON_SIZE}
          strokeWidth={3}
          aria-hidden
        />
        <Label
          x={left + PADDING_X + ICON_SIZE + ICON_GAP}
          y={top + BADGE_HEIGHT / 2}>
          {label}
        </Label>
      </ScreenScale>
    </g>
  )
}
